var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 37,
    viewBox: "0 0 250 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_4719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8326 13.227C17.079 14.2609 17.2023 15.4918 17.2023 16.8703V20.7352C17.2023 22.1138 17.079 23.3446 16.8326 24.3785C16.5861 25.4124 16.1672 26.274 15.6496 26.9387C15.1074 27.628 14.3927 28.1449 13.5548 28.465C12.7415 28.785 11.7311 28.9573 10.5727 28.9573H2.14412C1.38012 28.9573 0.665417 28.5634 0.271096 27.8988C0.14787 27.6772 0.0492902 27.4064 0 27.1356L0.0246451 10.3222C0.0739352 10.1253 0.172516 9.9037 0.271096 9.70677C0.640772 9.11596 1.2569 8.72208 1.97161 8.67285V8.64823H10.5727C11.7311 8.64823 12.7169 8.82055 13.5548 9.14057C14.3927 9.4606 15.1074 9.97755 15.6496 10.6422C16.1672 11.3315 16.5861 12.1931 16.8326 13.227ZM3.62283 25.1663C3.62283 25.2647 3.64747 25.2894 3.64747 25.2894H10.4988C11.0656 25.2894 11.5585 25.2401 11.9529 25.0924C12.3472 24.9447 12.6429 24.7232 12.8647 24.4278C13.1112 24.1077 13.2837 23.6893 13.3823 23.1477C13.4809 22.6061 13.5548 21.9168 13.5548 21.1045V16.5011C13.5548 15.6887 13.4809 14.9994 13.3823 14.4332C13.2837 13.9163 13.1112 13.4978 12.8647 13.1778C12.6429 12.8577 12.3472 12.6608 11.9529 12.5131C11.5585 12.3654 11.0656 12.2916 10.4988 12.2916H3.67212C3.64747 12.2916 3.62283 12.3408 3.62283 12.4393V25.1663ZM37.885 24.5262C38.1068 24.5262 38.5997 24.6001 38.5997 25.3632V28.0711C38.5997 28.8342 38.1068 28.9081 37.885 28.9081H29.136C28.0516 28.9081 27.1398 28.785 26.3758 28.4896C25.5871 28.2188 24.9464 27.7757 24.4535 27.1356C23.9852 26.5202 23.6155 25.7079 23.3937 24.7232C23.2212 23.9108 23.098 22.9261 23.0733 21.7691V21.646L23.1226 18.5443C23.1719 18.3227 23.2705 18.1258 23.3937 17.9289C23.7388 17.3134 24.3549 16.9442 25.0696 16.8949L37.7864 16.8703C37.9836 16.8703 38.4765 16.9442 38.4765 17.7073V19.6521C38.4765 20.4152 37.9836 20.5137 37.7864 20.5137H26.7701C26.7455 20.5137 26.7208 22.2861 26.7208 22.2861L26.7701 22.7046C26.844 23.1723 26.9919 23.5416 27.1891 23.8123C27.3862 24.0585 27.608 24.2308 27.9284 24.3539C28.2734 24.4524 28.6924 24.5262 29.21 24.5262H37.885ZM37.9097 8.599C38.1068 8.599 38.5997 8.69747 38.5997 9.4606V11.4053C38.5997 12.1685 38.1068 12.2669 37.9097 12.2669L23.7388 12.2423C23.5416 12.2423 23.0733 12.1685 23.0733 11.4053V9.48521C23.0733 8.69747 23.5416 8.599 23.7388 8.599H37.9097ZM65.0494 8.64823C65.8627 8.64823 66.4296 8.91902 66.7253 9.43598C66.9964 9.9037 67.1196 10.6914 67.1196 11.8238V28.0957C67.1196 28.8588 66.6267 28.9573 66.4049 28.9573H64.2855C64.0883 28.9573 63.5954 28.8588 63.5954 28.0957V13.2516H63.4722C63.4475 13.2516 63.4229 13.2516 63.4229 13.3009L59.1839 23.7385C59.0114 24.2554 58.8389 24.6986 58.6664 25.0678C58.4939 25.4371 58.2721 25.7325 58.0749 25.9786C57.8531 26.2248 57.582 26.4217 57.2863 26.5202C57.0152 26.6187 56.6701 26.6679 56.3004 26.6679H55.29C54.9203 26.6679 54.5999 26.6187 54.3042 26.5202C54.0085 26.4217 53.762 26.2248 53.5156 25.9786C53.3184 25.7325 53.1212 25.4371 52.9241 25.0678C52.7516 24.6986 52.579 24.2554 52.4065 23.7385L48.1922 13.3255C48.1676 13.2516 48.1429 13.2516 48.1183 13.2516H47.9951V28.0957C47.9951 28.8588 47.5268 28.9573 47.305 28.9573H45.1855C44.9637 28.9573 44.4708 28.8588 44.4708 28.0957V11.8238C44.4708 10.6914 44.594 9.9037 44.8651 9.43598C45.1609 8.91902 45.7277 8.64823 46.5656 8.64823H48.833C49.1534 8.64823 49.4491 8.67285 49.6956 8.7467C49.942 8.82055 50.1885 8.94364 50.3856 9.11596C50.5581 9.31289 50.7307 9.53445 50.8785 9.82985C51.0018 10.1253 51.1496 10.4945 51.2975 10.9622L55.635 21.843C55.6597 21.9414 55.709 21.9414 55.709 21.9414H55.9554C55.9801 21.9414 56.0047 21.9414 56.0294 21.843L60.3915 10.9622C60.5394 10.4945 60.6626 10.1253 60.8105 9.82985C60.9584 9.53445 61.1309 9.31289 61.3034 9.11596C61.5006 8.94364 61.7224 8.82055 61.9688 8.7467C62.2153 8.67285 62.4864 8.64823 62.8314 8.64823H65.0494ZM75.9481 8.64823C76.1453 8.64823 76.6382 8.7467 76.6382 9.50983V28.0957C76.6382 28.8588 76.1453 28.9573 75.9481 28.9573H73.6808C73.4836 28.9573 72.9907 28.8588 72.9907 28.0957V9.50983C72.9907 8.7467 73.4836 8.64823 73.6808 8.64823H75.9481ZM99.7855 27.8742C99.884 28.0219 99.9087 28.2188 99.884 28.465C99.8347 28.7604 99.6129 28.9573 99.3172 28.9573H96.6062C96.3844 28.9573 96.2119 28.9081 96.0887 28.8096C95.9901 28.7358 95.9162 28.6127 95.8176 28.465L91.3568 20.5629H86.1567V28.0957C86.1567 28.8588 85.6885 28.9573 85.4667 28.9573H83.224C83.0022 28.9573 82.5092 28.8588 82.5092 28.0957V17.7565C82.5092 16.9934 83.0022 16.9196 83.224 16.9196H93.9446C94.5853 16.9196 95.0043 16.7472 95.2508 16.378C95.5219 16.0087 95.6451 15.4179 95.6451 14.6056C95.6451 13.7932 95.5219 13.2024 95.2508 12.8331C95.0043 12.4639 94.5853 12.2916 93.9446 12.2916H83.224C83.0022 12.2916 82.5092 12.2177 82.5092 11.4546V9.50983C82.5092 8.72208 83.0022 8.64823 83.224 8.64823H94.5853C96.2612 8.64823 97.4935 9.16519 98.2328 10.2237C98.8982 11.233 99.2679 12.6608 99.3172 14.5317V14.6794C99.2679 16.5749 98.8982 18.0027 98.2328 18.9874C97.6167 19.8244 96.6802 20.3413 95.4726 20.489L99.7855 27.8742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.608 35.7734L117.11 30.7662C117.11 30.3056 117.698 30.7135 118.44 30.7135C119.175 30.7135 119.77 30.3056 119.77 30.7662L119.353 35.6496C119.353 36.7159 117.608 36.2817 117.608 35.7734Z",
    fill: "url(#paint0_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.474 19.4726C111.822 17.824 112.12 15.2284 112.12 15.2284C111.659 16.1445 112.639 24.1364 116.445 24.1364C118.148 24.1364 119.579 21.314 115.474 19.4726Z",
    fill: "url(#paint1_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.474 13.8255C111.822 12.182 112.12 9.58643 112.12 9.58643C111.659 10.5004 112.639 18.4945 116.445 18.4945C118.148 18.4945 119.579 15.6721 115.474 13.8255Z",
    fill: "url(#paint2_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.474 8.34823C111.822 6.71166 112.12 4.11133 112.12 4.11133C111.659 5.02745 112.639 13.0146 116.445 13.0146C118.148 13.0146 119.579 10.1995 115.474 8.34823Z",
    fill: "url(#paint3_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538 24.1364C124.343 24.1364 125.319 16.1445 124.863 15.2284C124.863 15.2284 125.158 17.824 121.504 19.4726C117.404 21.314 118.83 24.1364 120.538 24.1364Z",
    fill: "url(#paint4_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.474 25.2551C111.822 23.6068 112.12 21.0112 112.12 21.0112C111.659 21.9274 112.639 29.9193 116.445 29.9193C118.148 29.9193 119.579 27.0969 115.474 25.2551Z",
    fill: "url(#paint5_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538 29.9193C124.343 29.9193 125.319 21.9274 124.863 21.0112C124.863 21.0112 125.158 23.6068 121.504 25.2551C117.404 27.0969 118.83 29.9193 120.538 29.9193Z",
    fill: "url(#paint6_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538 18.4945C124.343 18.4945 125.319 10.5004 124.863 9.58643C124.863 9.58643 125.158 12.182 121.504 13.8255C117.404 15.6721 118.83 18.4945 120.538 18.4945Z",
    fill: "url(#paint7_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.538 13.0146C124.343 13.0146 125.319 5.02745 124.863 4.11133C124.863 4.11133 125.158 6.71166 121.504 8.34823C117.404 10.1995 118.83 13.0146 120.538 13.0146Z",
    fill: "url(#paint8_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.756 8.77515C122.793 8.77515 118.534 0.17749 118.534 0.17749C118.02 0.986246 114.719 8.77515 118.756 8.77515Z",
    fill: "url(#paint9_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.672 36.444L132.108 32.1855C132.302 31.7754 131.593 31.8876 130.927 31.5823C130.251 31.2694 129.891 30.6519 129.698 31.0693L128.037 35.8167C127.823 36.2817 129.219 37.4078 129.672 36.444Z",
    fill: "url(#paint10_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.975 20.1381C130.363 17.1061 131.723 14.8777 131.723 14.8777C130.92 15.5146 128.441 23.1774 131.888 24.7781C133.433 25.4963 135.922 23.5398 132.975 20.1381Z",
    fill: "url(#paint11_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.359 15.0136C132.746 11.9885 134.105 9.7605 134.105 9.7605C133.3 10.3952 130.817 18.0555 134.267 19.6613C135.817 20.3769 138.301 18.4252 135.359 15.0136Z",
    fill: "url(#paint12_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.668 10.0515C135.048 7.03125 136.414 4.7937 136.414 4.7937C135.611 5.43059 133.13 13.0887 136.581 14.6941C138.127 15.4076 140.613 13.4584 137.668 10.0515Z",
    fill: "url(#paint13_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.602 26.5051C139.053 28.101 143.312 21.2711 143.278 20.2428C143.278 20.2428 142.454 22.7218 138.444 22.6764C133.949 22.6288 134.054 25.7828 135.602 26.5051Z",
    fill: "url(#paint14_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.539 25.382C127.922 22.3518 129.283 20.1263 129.283 20.1263C128.48 20.7607 126 28.4213 129.45 30.0168C131 30.7351 133.481 28.7837 130.539 25.382Z",
    fill: "url(#paint15_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.163 31.7442C136.612 33.3474 140.871 26.5102 140.842 25.4867C140.842 25.4867 140.016 27.9654 136.008 27.9203C131.511 27.8723 131.619 31.0285 133.163 31.7442Z",
    fill: "url(#paint16_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.986 21.3836C141.434 22.9843 145.69 16.1448 145.662 15.1235C145.662 15.1235 144.835 17.6 140.828 17.5571C136.328 17.5091 136.438 20.6701 137.986 21.3836Z",
    fill: "url(#paint17_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.295 16.4116C143.747 18.017 147.998 11.1823 147.969 10.1566C147.969 10.1566 147.14 12.6422 143.138 12.5898C138.64 12.5422 138.75 15.6984 140.295 16.4116Z",
    fill: "url(#paint18_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.465 11.817C144.124 13.5155 143.89 3.92517 143.89 3.92517C143.083 4.45029 136.805 10.1182 140.465 11.817Z",
    fill: "url(#paint19_linear_333_4719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.236 11.1316L180.087 28.0076C180.184 28.2267 180.209 28.4459 180.16 28.592C180.111 28.7138 180.014 28.9573 179.624 28.9573H177.015C176.674 28.9573 176.43 28.7625 176.308 28.4216L170.262 13.3476L170.237 13.2989H170.14C170.14 13.2989 170.115 13.3233 170.091 13.372L166.97 21.2621H169.994C170.31 21.2621 170.579 21.4569 170.701 21.7491L171.578 23.9164C171.651 24.16 171.627 24.4278 171.481 24.6226C171.359 24.8418 171.115 24.9636 170.847 24.9636H165.508L164.118 28.4459C163.996 28.7625 163.752 28.9573 163.435 28.9573H160.754C160.364 28.9573 160.242 28.7381 160.217 28.592C160.169 28.4459 160.193 28.2267 160.266 28.0076L167.068 11.1316C167.409 10.2549 167.775 9.67049 168.141 9.35391C168.238 9.28086 168.36 9.18345 168.506 9.11039C168.994 8.76946 169.579 8.599 170.189 8.599C171.529 8.599 172.7 9.50002 173.09 10.7663L173.236 11.1316ZM202.522 8.86687C202.717 8.86687 203.204 8.96428 203.204 9.71919V11.6187C203.204 12.3979 202.717 12.471 202.522 12.471H192.16C191.648 12.471 191.209 12.544 190.892 12.6414C190.576 12.7632 190.356 12.9337 190.161 13.1772C189.99 13.4451 189.844 13.8103 189.771 14.2487C189.673 14.7357 189.625 15.3445 189.625 16.0751V21.7247C189.625 22.4553 189.673 23.0641 189.771 23.5512C189.844 24.0138 189.99 24.3791 190.161 24.6226C190.356 24.8905 190.576 25.061 190.892 25.1584C191.209 25.2801 191.648 25.3289 192.16 25.3289H198.987C199.255 25.3289 199.45 25.2558 199.572 25.061C199.669 24.9149 199.791 24.5983 199.791 23.8434L199.767 20.4341H193.696C193.501 20.4341 193.014 20.361 193.014 19.5574V17.7067C193.014 16.9274 193.501 16.83 193.696 16.83H202.327C202.644 16.83 203.18 16.9761 203.18 17.9015V24.4278C203.18 26.0594 202.936 27.204 202.473 27.8858C201.985 28.592 201.278 28.9573 200.376 28.9573H192.038C190.966 28.9573 190.039 28.8112 189.283 28.5433C188.528 28.2754 187.894 27.8128 187.406 27.204C186.919 26.5708 186.553 25.7672 186.333 24.8175C186.114 23.8434 186.017 22.6745 186.017 21.3108V16.4891C186.017 15.1497 186.114 13.9808 186.333 13.0311C186.553 12.057 186.919 11.2777 187.406 10.6446C187.869 10.0358 188.528 9.57308 189.283 9.28086C190.039 9.01298 190.966 8.86687 192.038 8.86687H202.522ZM226.102 27.8858C226.2 28.0319 226.224 28.2267 226.2 28.4703C226.151 28.7625 225.932 28.9573 225.639 28.9573H222.957C222.738 28.9573 222.567 28.9086 222.445 28.8112C222.348 28.7381 222.275 28.6164 222.177 28.4703L217.764 20.6533H212.62V28.105C212.62 28.8599 212.157 28.9573 211.938 28.9573H209.719C209.5 28.9573 209.012 28.8599 209.012 28.105V17.8771C209.012 17.1222 209.5 17.0492 209.719 17.0492H220.324C220.958 17.0492 221.373 16.8787 221.616 16.5134C221.885 16.1481 222.007 15.5637 222.007 14.7601C222.007 13.9564 221.885 13.372 221.616 13.0067C221.373 12.6414 220.958 12.471 220.324 12.471H209.719C209.5 12.471 209.012 12.3979 209.012 11.643V9.71919C209.012 8.93993 209.5 8.86687 209.719 8.86687H220.958C222.616 8.86687 223.835 9.37826 224.566 10.4254C225.225 11.4238 225.59 12.8363 225.639 14.687V14.8331C225.59 16.7082 225.225 18.1206 224.566 19.0947C223.957 19.9227 223.03 20.4341 221.836 20.5802L226.102 27.8858ZM248.635 10.6446C249.122 11.2534 249.464 12.057 249.683 13.0311C249.878 13.9808 250 15.1497 250 16.4891V21.3108C250 22.6745 249.878 23.8434 249.683 24.7931C249.464 25.7672 249.122 26.5708 248.635 27.204C248.147 27.8128 247.513 28.2754 246.733 28.5433C245.977 28.8112 245.051 28.9573 243.978 28.9573H238.03C236.957 28.9573 236.03 28.8112 235.299 28.5433C234.519 28.2754 233.885 27.8128 233.397 27.1796C232.934 26.5708 232.568 25.7672 232.349 24.7931C232.13 23.8434 232.032 22.6745 232.032 21.3108V16.4891C232.032 15.1253 232.13 13.9808 232.349 13.0311C232.568 12.057 232.934 11.2534 233.397 10.6446C233.885 10.0358 234.519 9.57308 235.299 9.28086C236.055 9.01298 236.957 8.86687 238.03 8.86687H243.978C245.051 8.86687 245.977 9.01298 246.733 9.28086C247.513 9.57308 248.147 10.0358 248.635 10.6446ZM246.367 16.0751C246.367 15.3689 246.343 14.7601 246.245 14.273C246.172 13.8103 246.026 13.4451 245.831 13.1772C245.66 12.9337 245.417 12.7632 245.1 12.6414C244.783 12.544 244.368 12.471 243.856 12.471H238.151C237.639 12.471 237.225 12.544 236.908 12.6414C236.591 12.7632 236.347 12.9337 236.177 13.1772C235.982 13.4451 235.86 13.8103 235.762 14.273C235.689 14.7601 235.64 15.3689 235.64 16.0751V21.7491C235.64 22.4553 235.689 23.0641 235.762 23.5512C235.86 23.9895 235.982 24.3791 236.177 24.6226C236.347 24.8905 236.591 25.061 236.908 25.1584C237.225 25.2801 237.639 25.3289 238.151 25.3289H243.856C244.368 25.3289 244.783 25.2801 245.1 25.1584C245.417 25.061 245.66 24.8905 245.831 24.6226C246.026 24.3791 246.172 23.9895 246.245 23.5512C246.343 23.0641 246.367 22.4553 246.367 21.7491V16.0751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_333_4719",
    x1: 117.446,
    y1: 30.2724,
    x2: 121.286,
    y2: 31.7429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_333_4719",
    x1: 112.787,
    y1: 14.8039,
    x2: 120.44,
    y2: 19.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_333_4719",
    x1: 112.787,
    y1: 9.16193,
    x2: 120.44,
    y2: 13.5279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_333_4719",
    x1: 112.787,
    y1: 3.68705,
    x2: 120.438,
    y2: 8.05421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_333_4719",
    x1: 119.612,
    y1: 14.8039,
    x2: 127.265,
    y2: 19.1707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_333_4719",
    x1: 112.787,
    y1: 20.5867,
    x2: 120.44,
    y2: 24.9527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_333_4719",
    x1: 119.612,
    y1: 20.5867,
    x2: 127.265,
    y2: 24.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_333_4719",
    x1: 119.612,
    y1: 9.16193,
    x2: 127.265,
    y2: 13.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_333_4719",
    x1: 119.612,
    y1: 3.68705,
    x2: 127.263,
    y2: 8.05506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_333_4719",
    x1: 117.245,
    y1: -0.232219,
    x2: 122.699,
    y2: 1.7246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_333_4719",
    x1: 128.536,
    y1: 30.6482,
    x2: 133.644,
    y2: 33.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_333_4719",
    x1: 130.643,
    y1: 14.3989,
    x2: 136.895,
    y2: 16.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_333_4719",
    x1: 133.021,
    y1: 9.28168,
    x2: 139.277,
    y2: 11.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_333_4719",
    x1: 135.334,
    y1: 4.31493,
    x2: 141.587,
    y2: 6.50405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_333_4719",
    x1: 135.726,
    y1: 19.9329,
    x2: 142.185,
    y2: 27.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_333_4719",
    x1: 128.203,
    y1: 19.648,
    x2: 134.456,
    y2: 21.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_333_4719",
    x1: 133.289,
    y1: 25.177,
    x2: 139.744,
    y2: 32.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_333_4719",
    x1: 138.109,
    y1: 14.8137,
    x2: 144.566,
    y2: 21.9349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_333_4719",
    x1: 140.42,
    y1: 9.84696,
    x2: 146.873,
    y2: 16.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_333_4719",
    x1: 139.904,
    y1: 3.53949,
    x2: 146.104,
    y2: 6.44018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADE36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_4719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 36.645,
    fill: "white",
    transform: "translate(0 0.17749)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.8401cd143dce6b7e5ae28039dbc3d596.svg";
export { ForwardRef as ReactComponent };